/*global TweenLite:false */

(function () {
  var pub = {
    PRODUCT_SISTEMA: 'sistema',
    PRODUCT_CANDELABRA: 'candelabra',
    PRODUCT_FLORACION: 'floracion',
    LUM_PICCOLO: 'piccolo',
    LUM_MEDIO: 'medio',
    LUM_GRANDE: 'grande',
    BRACKET_SISTEMA1: 'sistema1',
    BRACKET_SISTEMA2: 'sistema2',
    BRACKET_SISTEMA3: 'sistema3'
  };
  pub.debug = false; // FIXME this breaks the layout, so remove all of this
  pub.getSVGText = function (draw, text) {
    //console.log(text);
    var t = draw.text(text);
    t.font({family: 'Arial', size: 70, leading: '1em'}); // jshint ignore:line
    return t;
  };
  pub.getSortFromDegree = function (degree) {
    if (degree>=360) {
      degree -=360;
    }
    return Math.sin(degree * Math.PI / 360);
  };

  pub.rotatePoint = function (pointX, pointY, originX, originY, angle) {
    angle = angle * Math.PI / 180.0;
    return {
      x: Math.cos(angle) * (pointX - originX) - Math.sin(angle) * (pointY - originY) + originX,
      y: Math.sin(angle) * (pointX - originX) + Math.cos(angle) * (pointY - originY) + originY
    };
  };

  pub.getAngleBetweenAngles = function (anglea, angleb) {
    if (anglea>angleb) {
      angleb += 360;
    }
    var middle = (Math.abs(anglea +((angleb-anglea) * 0.5) ));
    while( middle >= 360) {
      middle -= 360;
    }
    return middle;
  };


  pub.getDifferenceBetweenAngles = function (anglea, angleb) {
    var difference = anglea - angleb;
    while (difference < -180) {
      difference += 360;
    }
    while (difference > 180) {
      difference -= 360;
    }
    return difference;
  };


  if(typeof module !== 'undefined') {
    console.log('OLIVIO: module');
    module.exports = pub;
  } else {
    window.OLIVIO = pub;
  }
})();







